module.exports = __webpack_public_path__ + "img/lead-weibo.74ee8fdd.png";